<template>
  <v-row>
    <v-col>
      <v-row justify="center">
        <h2>Request New Test</h2>
      </v-row>
      <v-row justify="center" class="error--text mt-3">{{ error }}</v-row>
      <v-row>
        <v-col>
          <iframe :src="intakeFormUrl" class="intake-form-frame" frameborder="0"></iframe>
        </v-col>
      </v-row>
    </v-col>
  </v-row> 
</template>

<script>
  export default {
    name: 'RequestNewTest',

    data () {
      return {
        error: '',
        intakeFormUrl: process.env.VUE_APP_INTAKE_FORM_URL || 'https://surveys.daqa.net/s/survey'
      }
    }
  }
</script>

<style scoped>

  .intake-form-frame {
    width: 100%;
    min-height: 560px;
    height: calc(100vh - 220px);
    border: 0;
    display: block;
  }

</style>